export const DMI_ZEST_ROUTE = "/dmi-zest-dashboard";
export const DMI_THEME_CLASS = "dmi-zest-theme";

export const isDmiZestRoute = (pathname: string) =>
  pathname.startsWith(DMI_ZEST_ROUTE);
